export default __webpack_public_path__ + "1cd6601.png";